import Router from './router';
import urlToPageName from './url-to-page-name';

export { Router, urlToPageName };
